<template>
  <div class="coupon-page">
    <div class="title">我的优惠券</div>
    <div class="coupon-box">
      <CouponItem v-for="(item, index) in coupons" :item="item" :key="index" />
    </div>
  </div>
</template>

<script>
import * as api from '@/services';
import CouponItem from './components/CouponItem';
export default {
  components: {
    CouponItem
  },
  mounted() {
    this.getCoupons();
  },
  methods: {
    async getCoupons() {
      const params = {
        scene: 5,
        couponScope: 0
      };
      const data = await api.personal.getCouponInfo(params);
      this.coupons = data.platformCouponInfos.concat(data.shopCouponInfos);
    }
  },
  data() {
    return {
      coupons: []
    };
  }
};
</script>

<style lang="scss" scoped>
.coupon-page {
  min-height: 539px;
  background-color: #ffffff;
  .title {
    padding-left: 24px;
    height: 42px;
    border-bottom: 1px solid #eeeeee;
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    line-height: 42px;
  }
  .coupon-box {
    display: flex;
    flex-wrap: wrap;
    padding-left: 58px;
    margin-top: 24px;
  }
}
</style>
